import React from "react";
import ReactDOM from "react-dom";
import nextId from "react-id-generator";
import CustomCheckBox from "../CustomCheckbox/CustomCheckBox";
import "./edit-personal-details.style.scss";
export default function EditPersonalDetails({
  data,
  message,
  onlySKills,
  closeIt,
  loading,
  onSubmit,
  changeSkills,
}) {
  const [personalDetails, setPersonalDetails] = React.useState({
    _id: data._id,
    candidate_email: "",
    candidate_full_name: "",
    candidate_gender: "",
    candidate_id: "",
    candidate_img: "",
    candidate_current_location: "",
    candidate_primary_contact_no: "",
    candidate_total_experience: "",
    candidate_skill: [],
  });

  const handleSkill = (data, add) => {
    if (add) {
      setPersonalDetails({
        ...personalDetails,
        candidate_skill: [...personalDetails.candidate_skill, data],
      });
    } else {
      if (personalDetails.candidate_skill.length === 1) {
        setPersonalDetails({
          ...personalDetails,
          candidate_skill: [],
        });
      } else {
        let tempArray = personalDetails.candidate_skill;
        tempArray.splice(data, 1);
        setPersonalDetails({
          ...personalDetails,
          candidate_skill: [...tempArray],
        });
      }
    }
  };

  React.useEffect(() => {
    setPersonalDetails({
      _id: data._id,
      candidate_email: data.candidate_email,
      candidate_full_name: data.candidate_full_name,
      candidate_gender: data.candidate_gender,
      candidate_id: data.candidate_id,
      candidate_img: data.candidate_img,
      candidate_current_location: data.candidate_current_location,
      candidate_primary_contact_no: data.candidate_primary_contact_no,
      candidate_skill: data.candidate_skill,
      candidate_total_experience: data.candidate_total_experience
    });
  }, []);
  return ReactDOM.createPortal(
    <div onClick={() => closeIt()} className="edit-personal-details">
      <div
        onClick={(e) => e.stopPropagation()}
        className="edit-personal-details-modal"
      >
        <header className="epdm-header">
          <span></span>
          <h5>{message}</h5>
          <span onClick={() => closeIt()}>x</span>
        </header>
        <div className="epdm-body">
          {onlySKills ? (
            ""
          ) : (
            <>
              {" "}
              <div className="fancy-input-wrapper">
                <span>Full name</span>
                <input
                  // disabled
                  onChange={(e) =>
                    setPersonalDetails({
                      ...personalDetails,
                      candidate_full_name: e.target.value,
                    })
                  }
                  placeholder=""
                  value={personalDetails.candidate_full_name}
                />
              </div>
              <div className="fancy-input-wrapper phone">
                <span>Contact No.</span>
                <div>
                  <input disabled value={"+91"} type="" />
                  <input
                    onChange={(e) =>
                      setPersonalDetails({
                        ...personalDetails,
                        candidate_primary_contact_no: e.target.value,
                      })
                    }
                    value={personalDetails.candidate_primary_contact_no}
                    placeholder="XXXXXXXXXX"
                  />
                </div>
              </div>
              <div className="fancy-input-wrapper">
                <span>Current Location</span>
                <input
                  onChange={(e) =>
                    setPersonalDetails({
                      ...personalDetails,
                      candidate_current_location: e.target.value,
                    })
                  }
                  placeholder=""
                  value={personalDetails.candidate_current_location}
                />
              </div>
            </>
          )}
          <div
            style={data.candidate_fresher ? { display: "none" } : {}}
            className={`fancy-input`}
          >
            <span>Total Work Experience</span>
            <input
              onChange={(e) =>
                setPersonalDetails({
                  ...personalDetails,
                  candidate_total_experience: e.target.value,
                })
              }
              type="number"
              value={personalDetails.candidate_total_experience}
              placeholder="Total Experience"
            />
          </div>

          {onlySKills ? (
            <div className="skills-wrapper">
              <div className="skills-list">
                <span>Mention Skills</span>
                {personalDetails.candidate_skill.map((x, num) => (
                  <button>
                    {x}
                    <span onClick={() => handleSkill(num, false)}>
                      <img src="https://img.icons8.com/ios/50/000000/delete-sign--v1.png" />
                    </span>
                  </button>
                ))}
                <input
                  onKeyPress={(e) => {
                    if (e.which === 13) {
                      handleSkill(e.target.value, true);
                      e.target.value = "";
                    }
                  }}
                  placeholder="+Add New"
                />
              </div>
            </div>
          ) : (
            ""
          )}
          {onlySKills ? (
            ""
          ) : (
            <CustomCheckBox
              handleChange={(obj) =>
                setPersonalDetails({
                  ...personalDetails,
                  candidate_gender: obj.id,
                })
              }
              list={genderList}
              selected={personalDetails.candidate_gender}
              title="Gender"
            />
          )}
          <div className="epdm-footer">
            <button
              onClick={() =>
                onlySKills
                  ? changeSkills({
                      candidate_skill: personalDetails.candidate_skill,
                    })
                  : onSubmit(personalDetails)
              }
            >
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
const genderList = [
  { keyId: nextId(), name: "Male", id: "male" },
  { keyId: nextId(), name: "Female", id: "female" },
];
